import { RootState } from '../../model/model'

export const selectCursorState = (state: RootState) => state.cursor.cursor
export const selectCursorPosition = (state: RootState) => state.cursor.position
export const selectCursorKey = (state: RootState) => state.cursor.key
export const selectZoomPosition = (state: RootState) => state.cursor.zoomPosition
export const selectZoomIndex = (state: RootState) => state.cursor.zoomIndex
